export default "__VITE_ASSET__BGXi5iMy__"